module.exports = __webpack_public_path__ + "static/media/DSC_0223.f3eff5ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scenery/DSC_0223.jpg
// module id = 695
// module chunks = 0